import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBanner = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.29463 13.8819C2.97111 13.8819 2.69424 13.7668 2.46405 13.5366C2.23346 13.306 2.11816 13.029 2.11816 12.7054V3.29366C2.11816 2.97013 2.23346 2.69327 2.46405 2.46307C2.69424 2.23248 2.97111 2.11719 3.29463 2.11719H12.7064C13.0299 2.11719 13.307 2.23248 13.5376 2.46307C13.7678 2.69327 13.8829 2.97013 13.8829 3.29366V12.7054C13.8829 13.029 13.7678 13.306 13.5376 13.5366C13.307 13.7668 13.0299 13.8819 12.7064 13.8819H3.29463ZM3.29463 12.7054H12.7064V4.47013H3.29463V12.7054Z" })
});
export default SvgBanner;
